module.exports = __webpack_public_path__ + "static/media/avatar.b89ba21f.png";